import { render, staticRenderFns } from "./MpStokListesiButton.vue?vue&type=template&id=1a20e976"
import script from "./MpStokListesiButton.vue?vue&type=script&lang=js"
export * from "./MpStokListesiButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports